export const CtaObjectConstants = {
    dataCta: "data-cta",
    dataCtaCategory: "data-cta-category",
    dataCustomCtaCategory: "data-custom-cta-category"
};
